// ============================================
// OLA Cosmetics — Ultra Premium Scroll Engine
// Every section animated, parallax, 3D, morph
// ============================================
(function() {
  'use strict';

  // 1. REVEAL ON SCROLL
  //
  // Most of this shop starts at opacity: 0 and is brought back by the class this observer
  // adds. That makes this the single line of code between a shopper and a blank page, so
  // it is written to fail towards visible in every direction. The stylesheet covers the
  // cases where this file never ran; what is here covers the cases where it did and the
  // observer still did not deliver.
  const revealAll = () => document.querySelectorAll('.reveal:not(.revealed), .reveal-stagger:not(.revealed)')
    .forEach(el => el.classList.add('revealed'));

  if (!('IntersectionObserver' in window)) {
    revealAll();
  } else {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

    /* Anything already on screen after three seconds has either been seen by the observer
       or never will be, and either way it should be readable. Only what is in the viewport
       is forced, so the effect still plays for everything further down the page. */
    setTimeout(() => {
      document.querySelectorAll('.reveal:not(.revealed)').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('revealed');
      });
    }, 3000);
  }

  // 2. TEXT COLOR REVEAL ON SCROLL
  function updateTextReveal() {
    document.querySelectorAll('.text-reveal').forEach(el => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      let progress = 1 - (rect.top - vh * 0.3) / (vh * 0.55);
      progress = Math.max(0, Math.min(1, progress));
      const gray = Math.round(220 - progress * 192);
      el.style.color = `rgb(${gray},${gray},${gray})`;
      el.querySelectorAll('.text-reveal__img').forEach(img => {
        img.style.opacity = progress;
        img.style.transform = `scale(${0.85 + progress * 0.15})`;
      });
    });
  }

  // 3. PARALLAX
  function updateParallax() {
    document.querySelectorAll('[data-parallax]').forEach(el => {
      const speed = parseFloat(el.dataset.parallax) || 0.15;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        const center = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = `translateY(${center * speed * 100}px)`;
      }
    });
  }

  // 4. SLIDE-IN FROM SIDES
  const slideObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('slid-in');
        slideObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
  document.querySelectorAll('.slide-from-left, .slide-from-right, .slide-from-bottom, .scale-in').forEach(el => slideObs.observe(el));

  // 5. HEADER: visible to the carousel line, gone below it
  // A POSITION rule, not a direction one. An earlier version hid on scroll-down and
  // revealed on scroll-up, which made the header flicker in and out during ordinary
  // reading. It now simply stops existing once the product carousel reaches the top,
  // and comes back only when she scrolls above that line again.
  const header = document.querySelector('.rh-header') || document.querySelector('.site-header');

  function headerHideLine() {
    // The carousel is the agreed line. Without that section, fall back to one viewport,
    // which is the sensible equivalent on an inner page.
    const carousel = document.querySelector('.rh-carousel-section');
    if (!carousel) return window.innerHeight;
    return carousel.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0);
  }

  // The real header height, published for any layout that needs to reason about it.
  // Measured again once fonts are ready, because the first reading lands while the
  // wordmark is still in a fallback face and comes out ~13px too tall.
  function publishHeaderHeight() {
    if (!header || header.classList.contains('header--hidden')) return;
    document.documentElement.style.setProperty('--rh-header-h', header.offsetHeight + 'px');
  }

  // A bare threshold flips the class on every pixel of jitter around the line: a
  // trackpad resting, a rubber-band settling, and each flip restarts a 320ms
  // animation. That stutter is what read as a bug. The header has to be well back
  // above the line before it is allowed to return.
  const HEADER_HYSTERESIS = 90;
  const hero = document.querySelector('.rh-hero');
  let headerHidden = false;

  function updateHeader() {
    if (!header) return;
    const y = window.scrollY;
    header.classList.toggle('header--shrink', y > 100);

    const line = headerHideLine();
    if (!headerHidden && y >= line) headerHidden = true;
    else if (headerHidden && y < line - HEADER_HYSTERESIS) headerHidden = false;
    header.classList.toggle('header--hidden', headerHidden);

    // Transparent for the WHOLE banner, not most of it.
    //
    // hero-banner.liquid used to own this with an IntersectionObserver at
    // threshold 0.1, which answers "is a tenth of the hero on screen" — a question
    // with no relationship to where the header actually is. The class came off
    // partway down the banner and the header snapped back to solid cream while the
    // photograph was still behind it, which is the flicker Guy saw.
    //
    // The rule that matches what the eye expects: transparent for exactly as long
    // as the photograph is behind the header. Since the product carousel starts
    // where the hero ends, that is also "until it reaches the carousel", where the
    // header leaves the screen anyway.
    if (hero) {
      const photoBehindHeader = hero.getBoundingClientRect().bottom > header.offsetHeight;
      header.classList.toggle('rh-header--transparent', photoBehindHeader);
    }
  }

  publishHeaderHeight();
  window.addEventListener('resize', publishHeaderHeight, { passive: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(publishHeaderHeight);
  }
  // A hidden tab reports every rect as 0, so a state computed there is wrong. Recompute
  // when she comes back to it.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') { publishHeaderHeight(); updateHeader(); }
  });


  // 8. HERO FRAME: never wider than the photograph inside it
  //
  // The cover file is 1320x742. At full bleed the frame is 1476 CSS px, so the photo
  // was being stretched to 1.13x its own width before the scroll zoom even started —
  // and the zoom took it to 1.63x. Capping the frame at the file's own width is the
  // only way to reach 1:1 without a bigger upload, which Guy asked for explicitly.
  //
  // Read from the image rather than hardcoded: a phone loads a different file through
  // the <picture> source, and the day a larger cover is uploaded this cap stops binding
  // on its own and the banner goes back to full bleed with nothing to change here.
  (function heroFrame() {
    const heroImg = document.querySelector('.rh-hero__img--desktop, .rh-hero__img');
    const heroEl = document.querySelector('.rh-hero');
    if (!heroImg || !heroEl) return;

    // The srcset is the authority, not naturalWidth. Liquid builds that list from
    // image.width on the server, so it is the file's real size; naturalWidth reports
    // whatever bitmap the browser happens to hold, and a stale cached copy reported
    // 2269 for a file the CDN serves at 1320 — which would have set the cap 949px too
    // wide and quietly undone this whole change. naturalWidth stays as the fallback
    // for the case where no srcset was built at all.
    function fileWidth() {
      const ss = heroImg.currentSrc && heroImg.closest('picture')
        ? (heroImg.closest('picture').querySelector('source[srcset]') &&
           heroImg.currentSrc.indexOf('media') > -1 ? null : null)
        : null;
      const list = (heroImg.getAttribute('srcset') || '').match(/(\d+)w/g);
      if (list && list.length) {
        return Math.max.apply(null, list.map(function (x) { return parseInt(x, 10); }));
      }
      return heroImg.naturalWidth || 0;
    }

    // How far the frame may run past the file. Not a free parameter: at 1.00 the cover
    // was pixel-exact but sat in 143px gutters, which Guy found too small. Each step
    // here buys width and spends sharpness, and the two are worth comparing directly:
    //
    //   1.00  frame 1320  gutters 143px  upscale 1.02   pixel-exact, smallest banner
    //   1.08  frame 1426  gutters  93px  upscale 1.02   measured, not predicted
    //   1.10  frame 1452  gutters  ~80px upscale ~1.02   the setting below
    //   1.12  frame 1478  gutters   0px  upscale 1.14   full bleed again
    //
    // Note the 1.08 row: the frame stopped at 1326 rather than the 1426 the cap allowed,
    // because the page's own width ran out first, so the extra width cost almost no
    // sharpness at all. Between 1.00 and 1.10 the page is the binding constraint and
    // this number barely matters; past that the file becomes the constraint and every
    // step is paid for in magnification. 1.12 is where the gutters close entirely.
    const HERO_FRAME_TOLERANCE = 1.10;

    function apply() {
      const w = fileWidth();
      if (!w) return;
      // Only a cap. Where the viewport is already narrower — every phone — it does
      // nothing and the banner stays edge to edge.
      heroEl.style.setProperty('--rh-hero-max', Math.round(w * HERO_FRAME_TOLERANCE) + 'px');
    }

    if (heroImg.complete && heroImg.naturalWidth) apply();
    heroImg.addEventListener('load', apply);
    window.addEventListener('resize', apply, { passive: true });
  })();

  // 6. ANIMATED COUNTERS
  function updateCounters() {
    document.querySelectorAll('[data-count-to]').forEach(el => {
      if (el.dataset.counted) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        el.dataset.counted = 'true';
        const target = parseInt(el.dataset.countTo);
        const suffix = el.dataset.countSuffix || '';
        const dur = 2000, start = performance.now();
        function tick(now) {
          const p = Math.min((now - start) / dur, 1);
          el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
    });
  }

  // 7. (removed) SCROLL PROGRESS BAR — a gradient reading-progress strip belongs on a
  //    long-form article, not a store, and it grew from the wrong edge on an RTL page.

  // 8. 3D TILT on hover
  document.querySelectorAll('.tilt-3d').forEach(el => {
    el.addEventListener('mousemove', e => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) scale(1.02)`;
    });
    el.addEventListener('mouseleave', () => {
      el.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
      el.style.transform = '';
      setTimeout(() => el.style.transition = '', 500);
    });
  });

  // 9. MAGNETIC BUTTONS
  document.querySelectorAll('.btn--magnetic').forEach(btn => {
    btn.addEventListener('mousemove', e => {
      const r = btn.getBoundingClientRect();
      btn.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.2}px, ${(e.clientY - r.top - r.height / 2) * 0.2}px)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transition = 'transform 0.4s cubic-bezier(0.16,1,0.3,1)';
      btn.style.transform = '';
      setTimeout(() => btn.style.transition = '', 400);
    });
  });

  // 10. SMOOTH IMAGE LOAD
  //
  // AN EFFECT THAT FAILS TO INVISIBLE IS NOT AN EFFECT, IT IS A BUG WITH A TRANSITION.
  //
  // .img--fade-in sets opacity: 0 and only .loaded brings it back, so every photograph on
  // this shop is invisible until a class arrives. The owner opened the blush section on his
  // phone and found the product panels empty: cream, a gradient, a product name and two
  // arrows over nothing. The images had downloaded; the class had not arrived.
  //
  // Four ways it failed to arrive, and this now covers all four:
  //   an image that errors fires `error`, never `load`, and stayed at zero forever;
  //   a lazy image inside a collapsed carousel slide can be complete without either event
  //   having been seen by us;
  //   an image added to the page after this ran (quick view, an ajax grid, a re-rendered
  //   cart) got the class that hides it from CSS and no listener to undo it;
  //   and a bfcache restore on iOS brings the page back without re-running this file.
  //
  // The rule underneath it all: nothing here may leave a photograph hidden. Every path ends
  // at .loaded, including the ones that end in failure.
  const showImage = (img) => img.classList.add('loaded');

  const wireImage = (img) => {
    if (img.dataset.fadeWired) return;
    img.dataset.fadeWired = '1';
    // The page's main picture (the hero, a product's first photo, an article's lead
    // image) is marked eager or fetchpriority=high. Hiding it until it finished loading
    // meant it first painted at opacity 0, so the browser never counted it as the page's
    // largest paint: PageSpeed reported "no LCP" on the homepage (speed pass, 25.10.2026).
    // Those images now simply appear; everything below the fold still fades in.
    if (img.getAttribute('fetchpriority') === 'high' || img.getAttribute('loading') === 'eager') { img.classList.add('loaded'); return; }
    if (!img.classList.contains('img--fade-in')) img.classList.add('img--fade-in');
    if (img.complete && img.naturalWidth) { showImage(img); return; }
    img.addEventListener('load', () => showImage(img), { once: true });
    // A broken image should show its own broken state, not a hole the size of the picture.
    img.addEventListener('error', () => showImage(img), { once: true });
  };

  const wireAllImages = () => document.querySelectorAll('img:not(.no-fade)').forEach(wireImage);
  wireAllImages();

  // Anything the page adds later, wired the moment it lands.
  if ('MutationObserver' in window) {
    new MutationObserver((records) => {
      for (const rec of records) {
        for (const node of rec.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') { if (!node.classList.contains('no-fade')) wireImage(node); }
          else if (node.querySelectorAll) node.querySelectorAll('img:not(.no-fade)').forEach(wireImage);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // The backstop. Whatever happened above, an image that has its pixels is shown.
  const sweepImages = () => document.querySelectorAll('img.img--fade-in:not(.loaded)').forEach((img) => {
    if (img.complete) showImage(img);
  });
  window.addEventListener('load', sweepImages);
  window.addEventListener('pageshow', () => { wireAllImages(); sweepImages(); });
  setTimeout(sweepImages, 1200);
  setTimeout(sweepImages, 4000);

  // 11. CURSOR GLOW
  if (window.matchMedia('(pointer:fine)').matches) {
    const g = document.createElement('div');
    g.className = 'cursor-glow';
    document.body.appendChild(g);
    document.addEventListener('mousemove', e => {
      g.style.left = e.clientX + 'px';
      g.style.top = e.clientY + 'px';
    }, { passive: true });
  }

  // 12. STAGGER GRID
  //
  // This is the one that holds the collection grid. Its children start at opacity 0 and
  // are brought back one by one from here, so the same rule applies as to the reveal above:
  // every path ends visible. .reveal itself is neutralised site wide in rhode-overrides,
  // which is why this mechanism, not that one, is what a shopper's product grid depends on.
  const staggerAll = () => document.querySelectorAll('.stagger-grid').forEach((grid) =>
    Array.from(grid.children).forEach((c) => c.classList.add('revealed')));

  if (!('IntersectionObserver' in window)) {
    staggerAll();
  } else {
    const staggerObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          Array.from(e.target.children).forEach((child, i) => {
            setTimeout(() => child.classList.add('revealed'), i * 120);
          });
          staggerObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.stagger-grid').forEach(el => staggerObs.observe(el));

    /* Same three second backstop, same reason: a grid that is on the screen and still
       invisible is a shop with no products in it. */
    setTimeout(() => {
      document.querySelectorAll('.stagger-grid').forEach((grid) => {
        const r = grid.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          Array.from(grid.children).forEach((c) => c.classList.add('revealed'));
        }
      });
    }, 3000);
  }

  // 12b. THE ONE THE PRODUCT GRID ACTUALLY USES.
  //
  // The collection cards are not .reveal and not .stagger-grid. Every card carries
  // data-animate="fade-up" inside a [data-stagger] wrapper, and assets/base.css holds both
  // at opacity: 0 until .is-visible arrives from assets/animation-controller.js. That is a
  // second file, loaded separately, with its own observer, and if it does not arrive the
  // collections page is nine empty rectangles.
  //
  // This does not duplicate that animation; it only refuses to let the page stay blank.
  // Three seconds is long after any real reveal has played, and only what is already on
  // the screen is forced, so a shopper who is looking at an empty grid gets her products
  // and a shopper scrolling down still gets the effect.
  const animateBackstop = () => {
    document.querySelectorAll('[data-animate]:not(.is-visible), [data-stagger] > *:not(.is-visible)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
    });
  };
  setTimeout(animateBackstop, 3000);
  window.addEventListener('pageshow', () => setTimeout(animateBackstop, 500));

  // 13. SCROLL INDICATORS
  document.querySelectorAll('.scroll-indicator').forEach(el => {
    el.addEventListener('click', () => {
      const next = el.closest('section, [class*="shopify-section"]')?.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // 14. HOVER ZOOM
  document.querySelectorAll('.hover-zoom').forEach(wrap => {
    const img = wrap.querySelector('img');
    if (!img) return;
    wrap.addEventListener('mousemove', e => {
      const rect = wrap.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - rect.left) / rect.width) * 100}% ${((e.clientY - rect.top) / rect.height) * 100}%`;
    });
  });

  // 15. QUICK-ADD FEEDBACK
  document.addEventListener('click', e => {
    const btn = e.target.closest('.fp-card__quick-add');
    if (!btn) return;
    const orig = btn.textContent;
    btn.innerHTML = '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'><path d=\'M20 6 9 17l-5-5\'/></svg> נוסף';
    btn.style.background = '#2d7a3a';
    setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 1600);
  });

  // 16. SPLIT SECTION PARALLAX
  function updateSplitParallax() {
    document.querySelectorAll('.split-section__media img').forEach(img => {
      const section = img.closest('.split-section');
      if (!section) return;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        const progress = (vh - rect.top) / (vh + rect.height);
        img.style.transform = `scale(1.1) translateY(${(progress - 0.5) * -40}px)`;
      }
    });
  }

  // 17. CATEGORY TEXT LINKS — color reveal
  function updateCategoryLinks() {
    document.querySelectorAll('.category-text-link').forEach(el => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.top < vh * 0.8 && rect.bottom > 0) {
        const progress = Math.max(0, Math.min(1, 1 - (rect.top / (vh * 0.8))));
        const gray = Math.round(200 - progress * 172);
        el.style.color = `rgb(${gray},${gray},${gray})`;
      }
    });
  }

  // 18. SECTION ENTRANCE: auto-add animation classes to all sections
  document.querySelectorAll('[class*="shopify-section"]').forEach((sec, i) => {
    const inner = sec.firstElementChild;
    if (inner && !inner.classList.contains('reveal') && !inner.classList.contains('hero-banner__media')) {
      // Don't add to hero or already-animated sections
      if (!inner.querySelector('.reveal') && !inner.classList.contains('marquee-text')) {
        // Already handled by individual sections
      }
    }
  });

  // MASTER SCROLL HANDLER
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateTextReveal();
        updateParallax();
        updateHeader();
        updateCounters();
        updateSplitParallax();
        updateCategoryLinks();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

})();
